module.exports = __webpack_public_path__ + "img/mobile-mapping-quote-headshot.49e308fd.png";